import React from "react";
import LocationBanner from "components/locationBanner";
import MainLanguages from "./MainLanguages";
import WhyChooseUs from "components/homepage/whyChooseUs";
import Reviews from "components/homepage/reviews";

function LanguageTranslationService() {
  return (
    <>
      <LocationBanner
        title="Language translation services"
        content="Tomedes has spent more than a decade building up a global network of professional translators. We cover a huge range of language pairings, translating over 120 languages. Our expert translators also offer a wide range of specialist knowledge and experience."
        backgroundCol="bg-midBlue"
        formOrangeHead="Get in touch  "
      />
      <MainLanguages />
      <WhyChooseUs backgroundCol="bg-darkBlue" />
      <Reviews backgroundCol="bg-midBlue" />
    </>
  );
}

export default LanguageTranslationService;
